export enum UserType {
  ADMINISTRATOR = "ADMINISTRATOR",
  GUARD = "GUARD",
  KIOSK = "KIOSK",
  OPERATOR = "OPERATOR",
  PUBLIC = "PUBLIC"
}